<div class="loader-bg">
  <div class="card">
    <app-logo-container [src]="'../../../assets/images/netsmart-careconnect-logo.png'" />
    <p class="loader-message">{{ LABEL_CONSTANT.LOADING_PLEASE_WAIT }}</p>
  </div>
</div>
